/**
 * Selectors for feature flags
 */

import { FEATURE_FLAGS_KEY } from './reducers';

/**
 * Get the given feature flag, or null if it doesn't exist
 * @param state the Redux state
 * @param flagKey the feature flag name/key
 */
export const getFeatureFlag = (state, flagKey) => state.getIn([FEATURE_FLAGS_KEY, flagKey]);

/**
 * Return all feature flags to send to analytics. All feature flag values
 * are changed to strings
 * @param state
 * @returns {*}
 */
export const getFeatureFlagsForAnalytics = state => state.getIn([FEATURE_FLAGS_KEY]).map(String);
